import { Fragment, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Remounts a debt's page when the route moves to another debt. React Router keeps a route's
 * element mounted across a param change, so without this one debt's page state (the selected
 * tab, an amount typed in) would carry onto the next — which the chat's page button reaches
 * in a single click.
 */
export function KeyedByDebt({ children }: { children: ReactNode }) {
  const { debtId } = useParams();
  return <Fragment key={debtId}>{children}</Fragment>;
}
